"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rendall API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArgumentToJSON = exports.ArgumentFromJSONTyped = exports.ArgumentFromJSON = exports.instanceOfArgument = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the Argument interface.
 */
function instanceOfArgument(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfArgument = instanceOfArgument;
function ArgumentFromJSON(json) {
    return ArgumentFromJSONTyped(json, false);
}
exports.ArgumentFromJSON = ArgumentFromJSON;
function ArgumentFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'and': !(0, runtime_1.exists)(json, 'and') ? undefined : (json['and'].map(ArgumentFromJSON)),
        'or': !(0, runtime_1.exists)(json, 'or') ? undefined : (json['or'].map(ArgumentFromJSON)),
        'not': !(0, runtime_1.exists)(json, 'not') ? undefined : (json['not'].map(ArgumentFromJSON)),
        'eq': !(0, runtime_1.exists)(json, 'eq') ? undefined : (json['eq'].map(ArgumentFromJSON)),
        '_in': !(0, runtime_1.exists)(json, 'in') ? undefined : (json['in'].map(ArgumentFromJSON)),
        'gt': !(0, runtime_1.exists)(json, 'gt') ? undefined : (json['gt'].map(ArgumentFromJSON)),
        'gte': !(0, runtime_1.exists)(json, 'gte') ? undefined : (json['gte'].map(ArgumentFromJSON)),
        'lt': !(0, runtime_1.exists)(json, 'lt') ? undefined : (json['lt'].map(ArgumentFromJSON)),
        'lte': !(0, runtime_1.exists)(json, 'lte') ? undefined : (json['lte'].map(ArgumentFromJSON)),
        'startsWith': !(0, runtime_1.exists)(json, 'startsWith') ? undefined : (json['startsWith'].map(ArgumentFromJSON)),
        'endsWith': !(0, runtime_1.exists)(json, 'endsWith') ? undefined : (json['endsWith'].map(ArgumentFromJSON)),
        'contains': !(0, runtime_1.exists)(json, 'contains') ? undefined : (json['contains'].map(ArgumentFromJSON)),
        'field': !(0, runtime_1.exists)(json, 'field') ? undefined : json['field'],
        'constant': !(0, runtime_1.exists)(json, 'constant') ? undefined : json['constant'],
        'list': !(0, runtime_1.exists)(json, 'list') ? undefined : (json['list'].map(ArgumentFromJSON)),
    };
}
exports.ArgumentFromJSONTyped = ArgumentFromJSONTyped;
function ArgumentToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'and': value.and === undefined ? undefined : (value.and.map(ArgumentToJSON)),
        'or': value.or === undefined ? undefined : (value.or.map(ArgumentToJSON)),
        'not': value.not === undefined ? undefined : (value.not.map(ArgumentToJSON)),
        'eq': value.eq === undefined ? undefined : (value.eq.map(ArgumentToJSON)),
        'in': value._in === undefined ? undefined : (value._in.map(ArgumentToJSON)),
        'gt': value.gt === undefined ? undefined : (value.gt.map(ArgumentToJSON)),
        'gte': value.gte === undefined ? undefined : (value.gte.map(ArgumentToJSON)),
        'lt': value.lt === undefined ? undefined : (value.lt.map(ArgumentToJSON)),
        'lte': value.lte === undefined ? undefined : (value.lte.map(ArgumentToJSON)),
        'startsWith': value.startsWith === undefined ? undefined : (value.startsWith.map(ArgumentToJSON)),
        'endsWith': value.endsWith === undefined ? undefined : (value.endsWith.map(ArgumentToJSON)),
        'contains': value.contains === undefined ? undefined : (value.contains.map(ArgumentToJSON)),
        'field': value.field,
        'constant': value.constant,
        'list': value.list === undefined ? undefined : (value.list.map(ArgumentToJSON)),
    };
}
exports.ArgumentToJSON = ArgumentToJSON;
